<div class="row">
  <div class=" col-sm-6">
    <div class="input__container">
      <label for="agency-search">Sök byrå</label>
      <input id="agency-search" type="text" [(ngModel)]="search">
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12 col-sm-6">
    <table class="table table--small table--woo thead--info">
      <thead>
        <tr>
          <th>Byråer</th>
          <th></th>
        </tr>
      </thead>
    </table>
    <div class="scrollable__list border--left border">
      <table class="table table--small centered">
        <tbody>
          @for (agency of filteredAgencies; track $index) {
            <tr>
              <td>{{agency.nickname}}</td>
              <td (click)="addAgencyToUser(agency)"><button type="button" class="button primary-1 float-end" >
                Ge behörighet
              </button></td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
  <div class="col-12 col-sm-6">
    <table class="table table--small table--woo thead--info">
      <thead>
        <tr>
          <th>Valda byråer</th>
          <th></th>
          <th></th>
        </tr>
      </thead>
    </table>
    <div class="scrollable__list border">
      <table class="table table--small centered">
        <tbody>
          @for (agencyRole of model; track $index) {
            <tr>
              <td>{{agencyRole.agency.nickname}}</td>
              <td>
                <div class="d-flex align-items-center">
                  <input type="checkbox"
                         class="checkbox checkbox--inline"
                         [checked]="agencyRole.role === UserRole.agencyAdmin"
                         (change)="toggleRole(agencyRole)"
                         id="user-agency{{$index}}">
                  <label class="checkbox" for="user-agency{{$index}}">
                    <span class="text--small thin">Administratör</span>
                  </label>
                </div>
              </td>
              <td >
                <button type="button" class="button danger float-end" (click)="removeAgencyFromUser(agencyRole)">Ta
                  bort behörighet</button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
